const mutations = {
  setGroupUsers(state, data) {
    // API'den gelen grup ve kullanıcı verilerini düzenle
    state.groupUsers = data;
    
    // Düzleştirilmiş kullanıcı listesi oluştur (tüm gruplardan)
    const allUsers = [];
    data.forEach(group => {
      group.groupUsers.forEach(user => {
        // Aynı kullanıcının birden fazla grupta olabileceği için duplicate check
        if (!allUsers.find(u => u.userId === user.userId)) {
          allUsers.push({
            id: user.userId,
            userId: user.userId,
            name: user.name,
            groupName: group.groupName
          });
        }
      });
    });
    state.allUsers = allUsers;
  },
  setAnswerRateAnalyticData(state, data) {
    // API'den gelen veri zaten doğru formatta (ranges array ile)
    state.answerRateAnalyticData = data;
  },
  setAnswerTotalRateAnalyticData(state, data) {
    state.answerTotalRateAnalyticData = data;
  },
  setTouchingRateAnalyticData(state, data) {
    state.touchingRateAnalyticData = data;
  },
  setOperationalEfficiencyData(state, data) {
    state.operationalEfficiencyData = data;
  },
  setDailyOperationalEfficiencyData(state, { data, widgetId }) {
    // Eğer state'te henüz obje yoksa oluştur
    if (!state.dailyOperationalEfficiencyData) {
      state.dailyOperationalEfficiencyData = {}
    }
    // Widget ID'ye göre veriyi sakla
    state.dailyOperationalEfficiencyData[widgetId] = data
  },
  
  // Widget-specific data mutation
  setWidgetData(state, { widgetId, data }) {
    if (!state.widgetData) {
      state.widgetData = {}
    }
    state.widgetData[widgetId] = data
  },

  // Clear widget data when widget is removed
  clearWidgetData(state, widgetId) {
    if (state.widgetData && state.widgetData[widgetId]) {
      delete state.widgetData[widgetId]
    }
  }
};

export default mutations;
